import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboardingContext } from '../../context/OnboardingContext/OnboardingContext';
import { useIsDesktop } from '../../utils/mediaQueries';
import { ActionButton } from '../Button/Button';
import TOU from '../TOU/TOU';
import styles from './styles';
export const OnboardingTOU = () => {
    const { t: text } = useTranslation();
    const { updateStep } = useOnboardingContext();
    const isDesktop = useIsDesktop();
    const [checked, setChecked] = React.useState(false);
    const { processOnboarding } = useOnboardingContext();
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const touState = React.useMemo(() => ({
        touDocName: 'Tech Trial Agreement',
        touDocVersion: '0.1.0',
        dataTrackingConsent: true,
    }), []);
    const handleSubmit = async (step) => {
        try {
            await processOnboarding(touState, step);
        }
        catch (e) {
            console.log('TOU update error', e);
        }
    };
    return (_jsxs(Box, { sx: styles.pageContentWrapper(false), children: [isDesktop && (_jsxs(Box, { sx: { flex: '0', width: '100%!important' }, children: [_jsx(Typography, { variant: 'h1', sx: { mt: '1rem' }, children: text('ONBOARDING_TOU_TITLE') }), _jsx(Box, { sx: styles.subtitle, children: _jsx(Typography, { variant: 'subtitle2', sx: { margin: '1rem 0 0' }, children: text('ONBOARDING_TOU_SUBTITLE') }) })] })), _jsx(Box, { mb: 2, mt: 3, sx: { width: '100%!important' }, children: _jsx(TOU, {}) }), _jsx(Box, { children: _jsx(FormControlLabel, { required: true, control: _jsx(Checkbox, { checked: checked, onChange: handleChange, sx: {
                            color: '#707272',
                            '&.Mui-checked': {
                                color: '#707272',
                            },
                        } }), label: text('ONBOARDING_TOU_CHKBX_LABEL') }) }), _jsxs(Box, { sx: styles.ctaButtonsTOUWrapper, children: [_jsx(ActionButton, { type: 'secondary', text: text('SET_UP_SMS_GO_BACK'), onClick: () => {
                            updateStep(0);
                        } }), _jsx(ActionButton, { type: 'primary', disabled: !checked, text: text('CONTINUE'), onClick: () => {
                            handleSubmit(2);
                        } })] })] }));
};
